export const ENCARGOS_ADD_ARTICLE_FROM_ENCARGO = 'ENCARGOS_ADD_ARTICLE_FROM_ENCARGO';
export const ENCARGOS_REMOVE_ARTICLE_FROM_ENCARGO = 'ENCARGOS_REMOVE_ARTICLE_FROM_ENCARGO';
export const ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_REQUEST = 'ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_REQUEST';
export const ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_SUCCESS = 'ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_SUCCESS';
export const ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_FAILURE = 'ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_FAILURE';
export const ENCARGOS_SET_WORKSPACE = 'ENCARGOS_SET_WORKSPACE';
export const ENCARGOS_SET_LOADING = 'ENCARGOS_SET_LOADING';
export const ENCARGOS_CREAR_PRESUPUESTO_RAPIDO = 'ENCARGOS_CREAR_PRESUPUESTO_RAPIDO';
export const ENCARGOS_MARCAR_ARTICULOS = 'ENCARGOS_MARCAR_ARTICULOS';
export const ENCARGOS_DEVOLVER_ARTICULOS_REQUEST = 'ENCARGOS_DEVOLVER_ARTICULOS_REQUEST';
export const ENCARGOS_DEVOLVER_ARTICULOS_SUCCESS = 'ENCARGOS_DEVOLVER_ARTICULOS_SUCCESS';
export const ENCARGOS_DEVOLVER_ARTICULOS_FAILURE = 'ENCARGOS_DEVOLVER_ARTICULOS_FAILURE';
export const ENCARGOS_COBRAR_REQUEST = 'ENCARGOS_COBRAR_REQUEST';
export const ENCARGOS_COBRAR_SUCCESS = 'ENCARGOS_COBRAR_SUCCESS';
export const ENCARGOS_COBRAR_FAILURE = 'ENCARGOS_COBRAR_FAILURE';
export const ENCARGOS_SELECCIONAR_LINEA = 'ENCARGOS_SELECCIONAR_LINEA';
